import React from "react";
import { Regular5Style } from "./css/Regular5Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";

const regular_9_5 = (props) => {
  return (
    <Regular5Style>
      <div className="container9">
        <TemplateLogo logo={props.logo} />
        <TemplateWatermark watermark={props.watermark} />
        <div className="back-layer">
          <TemplateImage slideType={props.slideType} file={props.file} />
        </div>
        <div className="text-wrapper">
          <div className="yellow-bar">
            <div className="yellow-wrap top">
              <div className="bar yellow" />
              <div className="bar corn" />
            </div>
            <div className="yellow-wrap bottom">
              <div className="bar corn" />
              <div className="bar yellow" />
            </div>
          </div>
          <div className="wrap">
            <div className="inner-wrap">
              <TemplateText
                id={props.id}
                text={props.text}
                textStyle={props.textStyle}
                editStatus={props.editStatus}
                onInputSlideText={props.onInputSlideText}
              />
            </div>
          </div>
        </div>
      </div>
    </Regular5Style>
  );
};

export default regular_9_5;
